import { render, staticRenderFns } from "./ResourcesList.vue?vue&type=template&id=3bda3dbd&"
import script from "./ResourcesList.vue?vue&type=script&lang=js&"
export * from "./ResourcesList.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports